import { render, staticRenderFns } from "./RotatingMarker.vue?vue&type=template&id=8486da80&"
import script from "./RotatingMarker.vue?vue&type=script&lang=js&"
export * from "./RotatingMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports